export enum CustomFiltersEnum{
  UNREAD = 'unread',
  SLA_WARNING= 'sla_warning',
  OUTBOX='outbox',
  INBOX='inbox',
  SLA_EXCEEDED= 'sla_exceeded',
  NOT_SYNCED= 'not_synced',
  PROXY_WAITING_TARGET_RESOLUTION = 'proxy_waiting_target_resolution',
  MY_ISSUES='my_issues',
  MY_WATCHING_ISSUES='my_watching_issues'
}
